import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { PrintSize } from '../prop-types';
import PandaViewSimplePreview from './panda-view-simple-previews/panda-view-simple-preview';
import Spinner from '../../_utils/spinner';
import PhotoDpiNotice from './photo-quality/photo-dpi-notice';

const PandaViewSimplePreviews = props => {
  const {
    thumb_url: thumbUrl,
    raw_dimensions: rawDimensions,
    isWallet,
    showSize,
    size,
    quantity,
    showQuantity,
    showLowQualityWarning,
    crop,
    lowQualityInformationPosition,
    lowQualityInformationCSSClasses,
    recommendedPrintSize,
    hideLowQualityInformationTooltip,
  } = props;

  if (!thumbUrl) return <Spinner />;

  const orientation = () => {
    if (rawDimensions.h <= rawDimensions.w) return 'landscape';
    if (rawDimensions.h > rawDimensions.w) return 'portrait';
  };

  return (
    <div
      className={classNames(
        'preview d-flex justify-content-center align-items-center m-auto',
        orientation(),
        { wallet: isWallet }
      )}>
      <div className="panda-preview d-flex">
        {(isWallet ? ['left', 'right'] : ['single']).map(preview => (
          <PandaViewSimplePreview key={preview} {...props} />
        ))}
        {showSize && (
          <div
            className={classNames('size-value', {
              'd-none': quantity === 0,
            })}>
            {size.title + (size.options.border === true ? " Bordered": "")}
          </div>
        )}
        {showQuantity && <div className="quantity-value">{quantity}</div>}
        {showLowQualityWarning && (
          <PhotoDpiNotice
            size_area={size.area}
            raw_dimensions={rawDimensions}
            recommendedPrintSize={recommendedPrintSize}
            crop={crop}
            iconOnly={false}
            tooltipPosition={lowQualityInformationPosition}
            tooltipCSSClasses={lowQualityInformationCSSClasses}
            hideTooltip={hideLowQualityInformationTooltip}
          />
        )}
      </div>
    </div>
  );
};

PandaViewSimplePreviews.propTypes = {
  thumb_url: PropTypes.string,
  raw_dimensions: PropTypes.objectOf(PropTypes.number),
  isWallet: PropTypes.bool.isRequired,
  showSize: PropTypes.bool,
  size: PrintSize.isRequired,
  showQuantity: PropTypes.bool.isRequired,
  quantity: PropTypes.number.isRequired,
  showLowQualityWarning: PropTypes.bool,
  crop: PropTypes.arrayOf(PropTypes.number),
  lowQualityInformationPosition: PropTypes.string,
  lowQualityInformationCSSClasses: PropTypes.string,
  recommendedPrintSize: PrintSize,
  hideLowQualityInformationTooltip: PropTypes.bool,
};

PandaViewSimplePreviews.defaultProps = {
  showSize: false,
  thumb_url: null,
  raw_dimensions: null,
  crop: null,
  showLowQualityWarning: false,
  lowQualityInformationPosition: undefined,
  lowQualityInformationCSSClasses: undefined,
  recommendedPrintSize: null,
  hideLowQualityInformationTooltip: false,
};

export default PandaViewSimplePreviews;
